<template>
  <div>
    <!-- 手机端免申即享 -->
    <div class="headCon flex-row">
      <p>中介超市</p>
      <img
        @click="back"
        class="backIcon"
        src="@/assets/images/mobile/return.png"
        alt=""
      />
    </div>
    <div class="seachCon">
      <el-form :inline="true" :model="form" style="margin-left: 5px">
        <el-form-item>
          <el-input
            v-model="form.agencyname"
            placeholder="请输入中介名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.zjType" placeholder="选中介类型" clearable>
            <el-option
              v-for="item in options"
              :key="item.industryguid"
              :label="item.industryname"
              :value="item.industryguid"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button class="searchBtn" type="primary" @click="query"
        >查询</el-button
      >
    </div>
    <div class="mainCon">
      <div v-infinite-scroll="load" style="overflow: auto">
        <div
          class="listItem flex-row"
          v-for="(item, index) in zjListData"
          :key="index"
        >
          <el-row>
            <el-col :span="24" class="title">
              <span @click="toDetail(item)">{{ item.agencyname }}</span>
            </el-col>
            <el-col :span="24" class="time" style="margin: 10px 0">
              <p style="line-height: 26px">可办理服务：{{ item.service }}</p>
            </el-col>
            <el-col :span="24" class="time" style="margin-bottom: 10px">
              成交笔数：{{ item.dealcount }}笔
            </el-col>
            <el-col :span="24" class="time flex-row">
              <span>整体评价：</span>
              <el-rate
                style="margin-top: -5px"
                v-model="item.evaluate_mark"
                disabled
              >
              </el-rate>
              <span style="color: #949393">{{ item.evaluate_mark }}分</span>
            </el-col>
          </el-row>
        </div>
        <!-- <p v-if="loading">加载中...</p>
        <p v-if="noMore">没有更多了</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    return {
      form: {
        agencyname: "",
        zjType: "",
      },
      options: [],
      policyData: [],
      zjListData: [],
      count: 1,
      loading: false,
      pagesize: 10,
      total: 0,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      getDictList: "dictionary/getDictList",
      getDictLabel: "dictionary/getDictLabel",
    }),
    noMore() {
      //当起始页数大于总页数时停止加载
      return this.count >= this.total-1;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  created() {
    this.getZjType();
    this.getZjList();
  },
  mounted() {},
  methods: {
    load() {
      //滑到底部时进行加载
      this.loading = true;
      this.count += 1; //页数+1
      setTimeout(() => {
        this.getZjList(); //调用接口，此时页数+1，查询下一页数据
      }, 2000);
    },
    back() {
      this.$router.push("/suqiuMobile");
    },
    toDetail(item) {
      let data = JSON.stringify(item);
      sessionStorage.setItem("policyData", data);
      this.$router.push("/marketDetail");
    },
    query() {
      this.getZjList();
    },
    getZjType() {
      let url = "/dev-api/superMakert/zjcsIndustryList";
      this.$httpApi
        .post(url, {})
        .then((res) => {
          this.options = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getZjList() {
      let url = "/dev-api/superMakert/zjcsList";
      let params = {
        agencyname: this.form.agencyname,
        industryguid: this.form.zjType,
        pagesize: this.pagesize * this.count,
        currentpage: 0,
        scusesort: "ASC",
        mainsort: "ASC",
        areacode: "",
      };
      this.$httpApi
        .post(url, params)
        .then((res) => {
          this.loading = false;
          this.zjListData = res.data.agencylist;
          this.total = res.total;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style lang='scss' scoped>
.headCon {
  z-index: 100;
  width: 100%;
  height: 5.25rem;
  background: #36ab60;
  position: relative;
  p {
    width: 100%;
    font-size: 1.375rem;
    color: #fff;
    text-align: center;
    letter-spacing: 0.5rem;
  }
  .backIcon {
    width: 1.875rem;
    position: absolute;
    top: 1.875rem;
    left: 1.25rem;
  }
}
.seachCon {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  padding: 15px 0;
  ::v-deep .el-input__inner {
    border-radius: 20px;
    overflow: none;
    width: 9.0625rem;
  }
  ::v-deep .el-button--primary {
    background-color: #36ab60 !important;
    border: none;
    border-radius: 16px;
  }
  .searchBtn {
    position: absolute;
    top: 17px;
    right: 10px;
  }
}
.mainCon {
  width: 100%;
  border-top: 2px solid #e2e2e2;
  margin-top: -20px;
  height: calc(100vh - 100px);
  overflow: hidden;
  overflow-y: scroll;
  .listItem {
    min-height: 8.4375rem;
    border-bottom: 2px solid #e2e2e2;
    padding: 10px;
    .bottomTxt {
      border: 1px solid #36ab60;
      padding: 2px 5px;
      color: #36ab60;
    }
    .title {
      font-size: 1rem;
      color: #000;
      font-weight: 600;
    }
    .time {
      font-size: 0.875rem;
      color: #949393;
    }
  }
  ::v-deep .el-rate__icon {
    font-size: 28px;
  }
}
</style>
